(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-faq-hub"] && !Shopify.designMode) return;
  try {
    
function initialiseFAQ(root){
 if(root.dataset.faqReady)return;
 root.dataset.faqReady='true';
 const input=root.querySelector('[data-faq-search]');
 const topics=[...root.querySelectorAll('.tt-faq-topic')];
 const items=[...root.querySelectorAll('.tt-faq-item')];
 const status=root.querySelector('[data-faq-status]');
 root.querySelector('[data-faq-tools]').hidden=false;
 const normalise=text=>text.toLowerCase().replace(/s5\s*\+/g,'s5 plus').replace(/immobilization/g,'immobilisation');
 function filter(){
  const terms=normalise(input.value).trim().split(/\s+/).filter(Boolean);
  let count=0;
  items.forEach(item=>{
   const haystack=normalise(item.textContent);
   const matches=terms.every(term=>haystack.includes(term));
   item.hidden=!matches;
   if(matches)count++;
   item.open=terms.length>0&&matches;
  });
  topics.forEach(topic=>{topic.hidden=![...topic.querySelectorAll('.tt-faq-item')].some(item=>!item.hidden)});
  root.querySelectorAll('.tt-kb-panel').forEach(panel=>{panel.hidden=terms.length>0});
  root.querySelector('[data-faq-empty]').hidden=count!==0;
  status.textContent=(terms.length?root.dataset.matches:root.dataset.browse).replace('[count]',count);
 }
 function reveal(hash){
  let id;try{id=decodeURIComponent(hash.slice(1))}catch{return}
  const target=document.getElementById(id);
  if(!target||!root.contains(target))return;
  input.value='';filter();
  if(target.matches('details'))target.open=true;
  requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));
 }
 input.addEventListener('input',filter);
 root.querySelector('[data-faq-clear]').addEventListener('click',()=>{input.value='';filter();input.focus()});
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');
  if(!link||!root.isConnected)return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
  reveal(url.hash);
  const drawer=link.closest('header-drawer');
  if(drawer&&typeof drawer.close==='function')drawer.close();
 });
 window.addEventListener('hashchange',()=>reveal(location.hash));
 if(location.hash)reveal(location.hash);
}
document.querySelectorAll('[data-faq-hub]').forEach(initialiseFAQ);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-faq-hub]').forEach(initialiseFAQ));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-home-hero"] && !Shopify.designMode) return;
  try {
    
  const initHomeVideo = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 750px)');
    document.querySelectorAll('[data-tt-hero-video]').forEach(template => {
      if (template.dataset.ready) return;
      template.dataset.ready = 'true';
      const media = template.parentElement;
      const update = () => {
        let video = media.querySelector('video');
        if (!desktop.matches || reduced.matches || navigator.connection?.saveData) {
          if (video) { video.pause(); video.style.visibility = 'hidden'; }
          return;
        }
        if (!video) {
          media.append(template.content.cloneNode(true));
          video = media.querySelector('video');
          video.addEventListener('playing', () => { video.style.visibility = 'visible'; });
          video.style.visibility = 'hidden';
        }
        video.play().catch(() => {});
      };
      desktop.addEventListener('change', update);
      reduced.addEventListener('change', update);
      const schedule = () => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(update, { timeout: 3000 });
        else window.setTimeout(update, 1000);
      };
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    });
  };
  initHomeVideo();
  document.addEventListener('shopify:section:load', initHomeVideo);
  const initBoldHomeMotion = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tt-bold-reveal');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('#MainContent .tt-section__head, #MainContent .tt-card, #MainContent .tt-step, #MainContent .tt-split__copy, #MainContent .tt-home-monitor, #MainContent .tt-home-immob').forEach(element => observer.observe(element));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBoldHomeMotion, { once: true });
  else initBoldHomeMotion();
  document.addEventListener('shopify:section:load', initBoldHomeMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-protection-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tt-protection-launch').forEach(root=>{
root.querySelectorAll('[data-story-target]').forEach(link=>link.addEventListener('click',event=>{const target=root.querySelector(link.getAttribute('data-story-target'));if(target){event.preventDefault();target.scrollIntoView({behavior:'instant',block:'start'});}}));
});

  } catch(e) { console.error(e); }
})();
})();
